var map = {
	"./en.json": 1415,
	"./nl.json": 1416,
	"./tr.json": 1417
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1414;


//////////////////
// WEBPACK FOOTER
// ./src/utils/locales ^\.\/.*\.json$
// module id = 1414
// module chunks = 1